import React from 'react';
import { NavLink } from 'react-router-dom';

type SidebarLinkProps = { path: string };

export const SidebarLink: React.FC<SidebarLinkProps> = ({ path, children }) => (
  <NavLink
    className="inline-flex items-center select-none rounded px-2 py-1 space-x-2 cursor-pointer text-gray-500 text-sm ml-6"
    activeClassName="bg-primary-150 text-primary-500"
    to={path}
  >
    {children}
  </NavLink>
);
